import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders } from "@angular/common/http";
import {BackendService} from "../api/backend.service";

import { Observable } from 'rxjs';
import {TwitchChannel, TwitchAuthorization} from "../../modele/social-media/twitchModels";
export const TWITCH_API_KEY = 'yahb1eg5ilr16hsabnu8orc7psmrke';
export const TWITCH_API_URL = 'http://api.twitch.tv/kraken/helix/channels';
const httpOptions = {
    headers: new HttpHeaders({
'Content-Type' : 'application/json',
'Cache-Control': 'no-cache',

'Access-Control-Allow-Methods': "GET, POST"
})
};


@Injectable({
  providedIn: 'root'
})
export class TwitchService {
    log_prefix=this.constructor.name+":";
    private local_auth:TwitchAuthorization;

    TWITCH_API_KEY = 'yahb1eg5ilr16hsabnu8orc7psmrke';
    TWITCH_API_URL = 'https://api.twitch.tv/helix/search/channels';
    LIMIT: string = '10';
    userToken="yahb1eg5ilr16hsabnu8orc7psmrke"

    constructor(private http: HttpClient,
        private http2:HttpClient,
        private bes: BackendService,

      @Inject(TWITCH_API_KEY) private apiKey: string,
      @Inject(TWITCH_API_URL) private apiUrl: string) {
          this.getBackendAuthorization()

      }

    search(query:string):Observable<any>{

        const access_token = this.local_auth.access_token;
        let params:string = [
            `client_id=${this.TWITCH_API_KEY}`,
            `query=${query}`,
            `limit=${this.LIMIT}`

        ].join('&');
        let queryUrl: string = `${this.TWITCH_API_URL}?${params}`;

        return new Observable((observer)=>{

            fetch(
                queryUrl,
                {
                    headers: {
                        'client-id': 'yahb1eg5ilr16hsabnu8orc7psmrke',
                        'Authorization': 'Bearer ' + access_token
                    }
                }
            )
            .then(resp => { return resp.json() })
            .then(resp => {
                observer.next(resp);
            })
            .catch(err => {
                observer.next(err);
            });
        })


    }


    searchVideosForChannels(query:string):Observable<any>{
        let lp=this.log_prefix+"getBackendAuthorization:"+ this.local_auth.access_token;

        const access_token = this.local_auth.access_token;

        if(this.local_auth.access_token == undefined){
            setTimeout(()=>{
                this.search(query);
            },1000)
        }
        else{

                    let params:string = [
                        `${query}`,


                    ].join('&');

                    let queryUrl: string = `https://api.twitch.tv/helix/videos?user_id=${params}`;

                    return new Observable((observer)=>{
                        fetch(
                            queryUrl,
                            {
                                headers: {
                                    'client-id': 'yahb1eg5ilr16hsabnu8orc7psmrke',
                                    'Authorization': 'Bearer ' + access_token
                                }
                            }
                        )
                        .then(resp => { return resp.json() })
                        .then(resp => {
                            observer.next(resp);
                        })
                        .catch(err => {
                            observer.next(err);
                        });
                    })
        }

    }
    private getBackendAuthorization() {
        let lp=this.log_prefix+"getBackendAuthorization:";
        this.http.get(this.bes.twitchAuthorization()).subscribe((resp:TwitchAuthorization)=>{
            let {access_token} = resp['feeds'];
            let {token_type} = resp['feeds'];
            let {expires_in} = resp['feeds'];
            this.local_auth = resp['feeds'];

        })
    }


}




  // TWITCH_API_KEY = 'yahb1eg5ilr16hsabnu8orc7psmrke';
  // TWITCH_API_URL = 'https://api.twitch.tv/kraken/search/channels';
  // LIMIT: string = '10';
  //
  // constructor(private http: Http){
  // }
  // search(query:string){
  //     let params:string = [
  //         `client_id=${this.TWITCH_API_KEY}`,
  //         `q=${query}`,
  //         `limit=${this.LIMIT}`,

  //     ].join('&');
  //     let queryUrl: string = `${this.TWITCH_API_URL}?${params}`;
  //     return this.http.get(queryUrl).map((response:Response)=>{
  //     })
  // }
